const reacQueryConfig = {
  fetchInSensitive: {
    retry: false,
    staleTime: 120000,
  },

  mutationInSensitive: {
    retry: false,
  },
};

export default reacQueryConfig;
